import { cn } from "../../lib/utils";

/**
 * Get initials from a name
 * Examples: "John Doe" → "JD", "Alice" → "A", "Bob Smith Jr" → "BS"
 */
function getInitials(name) {
  if (!name) return "?";

  const parts = name.trim().split(" ").filter(Boolean);

  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }

  // First letter of first name + first letter of last name
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

/**
 * Generate a consistent color based on a string (name)
 * This ensures the same name always gets the same color
 */
function getColorFromString(str) {
  if (!str) return "bg-gray-500";

  // Hash the string to get a number
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Convert to a color index (we have 5 color options)
  const colorIndex = Math.abs(hash) % 5;

  const gradients = [
    "bg-gradient-to-tr from-amber-700 via-yellow-600 to-amber-400", // Gold coin
    "bg-gradient-to-tr from-gray-700 via-gray-500 to-gray-300", // Silver / platinum
    "bg-gradient-to-r from-neutral-800 via-slate-700 to-gray-600", // Obsidian / black metal
    "bg-gradient-to-tr from-orange-800 via-amber-700 to-yellow-600", // Bronze
    "bg-gradient-to-r from-slate-800 via-gray-700 to-slate-500", // Gunmetal / black platinum
  ];

  return gradients[colorIndex];
}

export function Avatar({ name, size = "default", className }) {
  const initials = getInitials(name);
  const bgColor = getColorFromString(name);

  const sizeClasses = {
    sm: "h-8 w-8 text-xs",
    default: "h-10 w-10 text-sm",
    lg: "h-12 w-12 text-base",
  };

  return (
    <div
      className={cn(
        "relative flex shrink-0 items-center justify-center rounded-full text-white font-semibold",
        bgColor,
        sizeClasses[size],
        className,
      )}
    >
      {initials}
    </div>
  );
}
